export default __webpack_public_path__ + "static/media/4g.51b702ae.svg";